import React from 'react'

const IconMenu = ({ color = '#033691' }) => (
  <svg height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/400/svg">
    <g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
      <path
        d="M21,16 L21,18 L3,18 L3,16 L21,16 Z M21,11 L21,13 L3,13 L3,11 L21,11 Z M21,6 L21,8 L3,8 L3,6 L21,6 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconMenu
